export default {"src":"/_next/static/media/money-growth.dc327a63.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};